import React from "react";
import style from "./Info.module.scss";
import classnames from "classnames";
import { formattedNumber } from "../../../../../FormattedNumber/FormattedNumber";

const PriceHighlight = ({ oldValue, newValue, maxDecimals }) => {
  const Status = {
    NONE: 0,
    UP: 1,
    DOWN: 2,
  };

  const nextStatus = isNaN(oldValue) ? Status.NONE : oldValue > newValue ? Status.DOWN : Status.UP;

  return (
    <div className={style.highlight}>
      <span>{formattedNumber(newValue, "price", maxDecimals)}</span>
      <i
        className={classnames(
          "fa",
          { "fa-blank": nextStatus == Status.NONE },
          { "fa-caret-up": nextStatus == Status.UP },
          { "fa-caret-down": nextStatus == Status.DOWN }
        )}
      ></i>
    </div>
  );
};

export default PriceHighlight;
